// Helper function to replace placeholder with value from formValues
export const replacePlaceholder = (text, values) => {
    const placeholderRegex = /{([^}]+)}/g;
    return text.replace(placeholderRegex, (_, key) => (values && values[key] !== undefined ? values[key] : `{${key}}`));
};